import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcceptRecievedImagesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 47,
	viewBox: "0 0 43 47",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25.8949,
			cy: 29.7727,
			rx: 3.76599,
			ry: 3.65554,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 21,
			cy: 26.2959,
			rx: 17,
			ry: 16.8935,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 26.4705L16.3271 32.5192L27 20.4219",
			stroke: "#068F61",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 39.5318,
			cy: 39.1658,
			rx: 2.53176,
			ry: 2.6111,
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.0127,
			cy: 45.9546,
			rx: 1.0127,
			ry: 1.04444,
			fill: "#068F61"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.0127,
			cy: 1.04444,
			rx: 1.0127,
			ry: 1.04444,
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 23.5,
			cy: 7.83375,
			rx: 2.5,
			ry: 2.6111,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 43.934C28.9 43.934 37 35.9209 37 26.1271C37 16.3334 28.9 8.32031 19 8.32031C9.1 8.32031 1 16.3334 1 26.1271C1 35.9209 9.1 43.934 19 43.934Z",
			stroke: "#068F61",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAcceptRecievedImagesIcon;
